import { createSelector } from "reselect";

//VIEW RESULTS
export const viewResultsSelector = createSelector(
    state => state.tracker.actionsInfo.viewResultsDialog,
    state => state
);
//VIEW SCRAPE_ATTEMPTS
export const viewScrapeAttemptsSelector = createSelector(
    state => state.tracker.actionsInfo.viewScrapeAttemptsDialog,
    state => state
);
//SOURCE TRACK
export const getSourceTrackSelector = createSelector(
    state => state.tracker.actionsInfo.viewSourceDialog,
    state => state
);
//STATUS HISTORY
export const getStatusHistorySelector = createSelector(
    state => state.tracker.actionsInfo.statusHistory,
    state => state
);

//View TrackerTree
export const getTrackTreeInfoSelector = createSelector(
    state => state.tracker.actionsInfo.trackTree,
    state => state
);

//VIEW METADATA
export const getTrackMetadataSelector = createSelector(
    state => state.tracker.actionsInfo.viewMetadataDialog,
    state => state
);

//VIEW BUFFER VARIABLES
export const getTrackBufferSelector = createSelector(
    state => state.tracker.actionsInfo.viewBufferDialog,
    state => state
);

//EXPORT RESULT OBJECT
export const downloadDialogSelector = createSelector(
    state => state.tracker.actionsInfo.downloadDialog,
    state => state
);
